import Model from "../classes/Model";
import DirectionShowApi from "../classes/api/DirectionShow";
import ValidationError from "../classes/ValidationError";

export default class DirectionShow extends Model {

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
        return {
            id: this.id,
            name: this.name,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            name: data.name,
        };
    }

    static getList(page = 1, perPage = 10) {
        return DirectionShowApi.getList(page, perPage).then((response) => {
            let data = [];
            for (let show of response.data) {
                data.push(new this(this.toResponse(show)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return DirectionShowApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return DirectionShowApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new DirectionShow(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return DirectionShowApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}